const spacing = {
  base: '1em',
  large: '1.5em',
  small: '.5em',
};

export default spacing;
